// extracted by mini-css-extract-plugin
module.exports = {"root":"productTag_root__1slDL","active":"productTag_active__3FhLr"};